import React from "react";

import { Box, Stack, SxProps, Typography } from "@mui/material";

import { getSemanticScore } from "@app/common/utils";

const METRIC_COLORS = {
  positive: "shades.meadow.400",
  neutral: "shades.orange.400",
  negative: "shades.negative.400",
  unknown: "shades.neutral.400",
};

const MetricWithIndicator = ({
  labelSx,
  sx,
  value,
}: {
  sx?: SxProps;
  labelSx?: SxProps;
  value?: number | null;
}) => {
  const semanticScore = getSemanticScore(value);
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" sx={sx}>
      {semanticScore !== "unknown" && (
        <Box
          sx={{
            borderRadius: "50%",
            height: "8px",
            width: "8px",
            backgroundColor: METRIC_COLORS[semanticScore],
            mr: 1,
          }}
        />
      )}
      <Typography variant="bodySecondaryReg" sx={{ mr: 1, ...labelSx }}>
        {value || "-"}
      </Typography>
    </Stack>
  );
};

export default MetricWithIndicator;
